<template>
  <div class="cmzExplain">
    <headBox title="方案定制" />
    <div class="inner">
      <div class="head">
        <div class="desc">
          <div class="left">
            <img src="@static/images/per.png" alt="" />
          </div>
          <div class="right">
            付费定制方案功能分为：单身贵族完整保障计划、温暖小家完整保障计划、三代同堂完整保障计划、带病投保人群完整保障计划等四种方案，客户支付的方案服务费由凤栖云服收取。定制方案不同于传统“推销为主”的方式，保险顾问会根据客户的需求为客户解读方案、制定保障方案、协助客户投保及帮助客户理赔。若您不需要我方的转化服务，您关闭授权即可。
          </div>
        </div>
      </div>
      <div class="content clearfix">
        <div class="pic">
          <img src="@static/images/marketing/phone6.png" alt="" />
        </div>
        <div class="info">
          <div class="item">
            <div class="infoTitle">凤栖云服方案定制</div>
            <!-- <p class="infoDesc">
              您可将定制方案配置在左图所示的工具栏中，也可获取以下链接、二维码放置在公众号菜单、文章等推广场景中。
            </p>
            <p class="infoDesc">
              <span>链接地址：{{ link }}</span
              ><el-button type="text" class="copy" @click="copy"
                >复制链接</el-button
              >
            </p>
            <div class="infoCode clearfix">
              <span class="lab">二维码：</span>
              <canvas class="codes" id="codes"></canvas>
              <el-button type="text" @click="download">下载二维码</el-button>
            </div> -->
          </div>
          <div class="item">
            <div class="title">定制流程</div>
            <div class="body">
              <div class="content">
                获取用户信息及沟通需求——进行风险分析——提供专业投保建议及保障方案规划——为用户解读方案——协助用户投保及后续维护。成功授权后，凤栖云服将以您的品牌名义进行服务。交易转化业绩为您的专属业绩
              </div>
              <div class="btn" @click="$router.push({path:'/setting/auth',query:{source:'1'}})">
                点击授权
              </div>
            </div>
          </div>
          <div class="item">
            <div class="title">功能入口</div>
            <div class="body">
              <div class="content">
                页面模板—工具栏配置入口 <br />
                其他-通用预约入口，可自行配置
              </div>
              <div class="btn" @click="getLink">获取入口链接</div>
            </div>
          </div>
          <div class="item">
            <div class="title">方案定制订单</div>
            <div class="body">
              <div class="content">
                您可进入转化跟进—方案定制跟进，查看已购买定制方案的客户，点击查看详情，可查看跟进结果、跟进流程以及方案详情
              </div>
              <div class="btn" @click="$router.push('/cmzOrder')">查看订单</div>
            </div>
          </div>
          <!-- <div class="item">
            <p class="infoTitle">定制方案流程</p>
            <p class="infoDesc">
              获取用户信息及沟通需求——进行风险分析——提供专业投保建议及保障方案规划——为用户解读方案——协助用户投保及后续维护。
            </p>
          </div> -->
          <!-- <div class="item">
            <p class="infoTitle">定制方案订单查看</p>
            <p class="infoDesc">
              您可进入定制方案—
              —定制方案订单，查看已购买定制方案的客户，点击查看详情，可查看跟进结果、跟进流程以及方案详情
            </p>
          </div> -->
        </div>
      </div>
    </div>
    <el-dialog class="isShowLink" :visible.sync="isShowLink" width="860px">
      <div class="top">
        <h1>获取方案定制入口链接</h1>
        <p>
          您可以将方案定制链接放置于你想推广的任意场景中，这些链接将有助于对推广渠道做统计分析
        </p>
      </div>
      <div class="tabBox">
        <el-tabs v-model="activeName">
          <el-tab-pane
            :label="item.txt"
            :name="item.code"
            v-for="(item, index) in tabList"
            :key="index"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div class="item">
        <div class="title">H5链接</div>
        <div class="content urlBox">
          <span>
            {{ h5Url }}
          </span>
          <span class="copyBtn" @click="copy">复制链接</span>
        </div>
      </div>
      <div class="item">
        <div class="title">H5二维码</div>
        <div class="content qrBox">
          <canvas id="codes"></canvas>
          <div class="downBtn" @click="download">下载二维码</div>
        </div>
      </div>
      <!--
      <div class="item">
        <div class="title">小程序路径</div>
        <div class="content">
          <span>
            https://www.fxyf99.com/m/plan/onePlan?source=bps&mechanId=1243069822374080512
          </span>
          <span class="copyBtn">复制链接</span>
        </div>
      </div>
      <div class="item">
        <div class="title">小程序码</div>
        <div class="content qrBox">
          <img src="" alt="" class="codeImg" />
          <div class="downBtn">下载二维码</div>
        </div>
      </div>
      <div class="item">
        <div class="title">PC链接</div>
        <div class="content">
          <span>
            https://www.fxyf99.com/m/plan/onePlan?source=bps&mechanId=1243069822374080512
          </span>
          <span class="copyBtn">复制链接</span>
        </div>
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
var QRCode = require("qrcode");
import commom from "../../api/common";
import headBox from "@/components/head.vue";
import Clipboard from "clipboard";
export default {
  data: () => ({
    code:"",
    link: "",
    isShowLink: false,
    activeName: "",
    tabList: [],
    h5Url: "",
  }),
  components: {
    headBox,
  },
  created() {
    //todo
    this.code = this.$tools.getLocal('code');
    this.getShortLink();
  },
  computed: {
    comUrl() {
      const url = `${this.$config.api_root}/yunying/m/exercise/customization_home.html?c=${this.code}`;
      return url;
    },
  },
  watch: {
    activeName() {
      const url = `${this.$config.api_root}/yunying/m/exercise/customization_home.html?c=${this.code}&lx=${this.activeName}`;
      this.getShortLink(url).then((res) => {
        this.h5Url = res;
        this.getCodeImg();
      });
    },
  },
  methods: {
    // handleClick() {
    //   this.getCodeImg();
    // },
    getLink() {
      this.isShowLink = true;
      this.getTab();
    },
    getShortLink(url) {
      return this.$http({
        url: "/bplatTool/transformLongUrl",
        type: "put",
        params: {
          url: encodeURIComponent(url),
        },
      }).then((res) => {
        this.link = res.data;
        return res.data;
      });
    },
    getTab() {
      this.$http({
        url: "/master/subscribeService/querySourceList",
        type: "put",
      }).then((res) => {
        this.tabList = res.data;
        this.activeName = this.tabList[0].code;
        this.getCodeImg();
      });
    },
    copy: function () {
      var that = this;
      var clipboard = new Clipboard(".copyBtn", {
        text: function () {
          return that.link;
        },
      });
      clipboard.on("success", function (e) {
        that.linkVisible = false;
        that.$message({
          message: "复制成功",
          type: "success",
        });
        clipboard.destroy();
      });
    },
    download: function () {
      var url = document.getElementById("codes").toDataURL("image/png");
      this.dataToBlob(url);
    },
    dataToBlob(data) {
      data = data.split(",")[1];
      data = window.atob(data);
      var ia = new Uint8Array(data.length);
      for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
      }
      var blob = new Blob([ia], {
        type: "image/jpeg",
      });
      var fd = new FormData();
      fd.append("img", blob, ".png");
      this.upload(fd);
    },
    upload: function (bold) {
      var that = this;
      this.$http({
        url: "/resmgr/upload",
        type: "post",
        params: bold,
      }).then(function (data) {
        console.log(data.data[0].wwwurl);
        window.open(
          decodeURI(
            commom.api_root +
              "/master/custom/download?filePath=/upload" +
              data.data[0].path +
              "&fileName=" +
              data.data[0].ts +
              ".png"
          )
        );
      });
    },
    getCodeImg() {
      var canvas = document.getElementById("codes");
      QRCode.toCanvas(canvas, this.h5Url,{width: 120, height: 120,margin:0}, function (error) {
        if (error) console.error(error);
        console.log("ssss!");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding-top: 0;
}
.copyBtn {
  width: 76px;
  height: 28px;
  background: #fff8e8;
  border: 1px solid #ffd7a0;
  color: #fd9201;
  font-size: 14px;
  border-radius: 4px;
  margin-left: 10px;
  line-height: 28px;
  text-align: center;
  word-break: keep-all;
  &:hover {
    cursor: pointer;
  }
}
.isShowLink {
  .top {
    font-size: 15px;
    color: #666;
    margin-bottom: 30px;
    h1 {
      font-size: 18px;
      color: #333;
      margin-bottom: 10px;
      font-weight: bold;
    }
  }
  .item {
    width: 100%;
    margin-top: 30px;

    &:nth-child(3) {
      margin-top: 0;
    }
    .codeImg {
      width: 120px;
      height: 120px;
      margin-right: 20px;
    }
    .downBtn {
      width: 124px;
      height: 36px;
      border: 1px solid #fd9201;
      opacity: 1;
      border-radius: 4px;
      font-size: 14px;
      line-height: 36px;
      text-align: center;
      color: #fd9201;
      margin-left: 20px;
      &:hover {
        cursor: pointer;
      }
    }
    .title {
      font-size: 16px;
      color: #333;
      position: relative;
      padding-left: 10px;
      margin-bottom: 8px;
      &:before {
        content: "";
        position: absolute;
        width: 3px;
        height: 13px;
        left: 0;
        top: 2px;
        background: #fd9201;
      }
    }
    .qrBox {
      display: flex;
      align-items: flex-end;
      margin-left: 10px;
    }
    .content {
      font-size: 14px;
      color: #666;
    }
  }
}
.tabBox {
  padding-bottom: 20px;
  background: #fff;
  padding-left: 0;

  /deep/ .el-tabs__item.is-active {
    color: #ff9700;
  }

  /deep/ .el-tabs__active-bar {
    background: #ff9700;
  }

  /deep/ .el-tabs__item {
    color: #666666;
    font-size: 16px;
  }

  /deep/ .el-tabs__item:hover {
    color: #ff9700;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #ececec;
  }
}
.cmzExplain {
  background: #fff;
  // padding: 20px;

  .inner {
    padding: 0 30px 20px 30px;
    > .content {
      margin-top: 24px;
    }
  }
  .head {
    // border-bottom: 1px solid #ebeef5;
    padding-bottom: 10px;
    .title {
      i {
        display: inline-block;
        width: 4px;
        height: 16px;
        background: #ff9700;
        vertical-align: middle;
      }
      span {
        font-size: 16px;
        vertical-align: middle;
        margin-left: 5px;
      }
    }

    .desc {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-left: 5px;
      line-height: 24px;
      margin-top: 15px;
      background: #f7f7f7;
      padding: 20px;
      .left {
        margin-right: 20px;
      }
    }
  }
  .content {
    margin-top: 10px;
    display: flex;

    &.urlBox {
      display: flex;
      align-items: center;
    }
    span:nth-child(1) {
      float: left;
    }
    .pic {
      float: left;
      width: 418px;
      position: relative;
      margin-left: 50px;
      .title {
        position: absolute;
        left: 0;
        top: 75px;
        text-align: center;
        width: 100%;
        font-size: 15px;
        color: #000000;
        font-weight: bold;
      }
      .targetIframe {
        width: 90%;
        margin: 0 auto;
        position: absolute;
        top: 110px;
        left: 20px;
        height: 690px;
        /deep/ html {
          overflow-x: hidden;
        }
      }
      img {
        @media screen and (max-width:1440px) {
          width: 80%;
        }
        @media screen and (min-width:1441px) {
          width: 100%;
        }
        display: block;
      }
    }
    .info {
      flex: 1;
      @media screen and (min-width:1441px) {
        margin-left: 87px;
      }
      .item {
        position: relative;
        margin-bottom: 40px;
        .content {
          width: 75% !important;
        }
        .body{
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-flow: row wrap;
        }
        &:nth-child(1) {
          margin-top: 0;
        }
        .btn {
          // position: absolute;
          // right: 0;
          // top: 30px;
          width: 124px;
          height: 36px;
          font-size: 14px;
          background: #fd9201;
          line-height: 36px;
          color: #ffffff;
          text-align: center;
          border-radius: 5px;
          &:hover {
            cursor: pointer;
          }
        }
        margin-top: 20px;
        .infoTitle {
          font-size: 18px;
          color: #333333;
          font-weight: bold;
        }
        .content {
          color: #666666;
          font-size: 14px;
          width: 84%;
          line-height: 1.7;
        }
        .title {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          position: relative;
          padding-left: 10px;
          &:before {
            content: "";
            position: absolute;
            width: 3px;
            height: 13px;
            left: 0;
            top: 2px;
            background: #fd9201;
          }
        }

        .titles {
          padding-top: 40px;
          border-top: 1px solid #ececec;
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          margin-bottom: 20px;
        }
      }
    }
    .last {
      .btn {
        top: 70px !important;
      }
    }
  }
}
</style>